<template>
  <div class="zjfx-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <div class="card-title">
            <el-form style="float: right;" :inline="true" size="small" :model="searchForm"  @submit.native.prevent >
              <el-form-item label="选择日期">
                <el-date-picker
                  v-model="searchForm.time"
                  format="yyyy年MM月dd日"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="车间">
                <el-select v-model="searchForm.fxfactory" style="width: 120px" filterable clearable>
                  <el-option v-for="item in factoryList" v-if="item.brand===0||group.dBrand===0||group.dBrand===item.brand" :label="item.simple_name" :value="item.factory_id" />
                </el-select>
              </el-form-item>
<!--              质检责任部门-->
              <el-form-item label="部门">
                <el-select v-model="searchForm.depts" style="width:440px;" clearable multiple placeholder="选择部门" >
                  <el-option v-for="d in qualityDeptList" :label="d.name" :value="d.qdid">{{d.name}}</el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button  icon="el-icon-s-data" type="primary" @click="selectQualityInfo">统计</el-button>
              </el-form-item>
            </el-form>
          </div>
          <br/>
          <div style="margin-top: 60px">
            <GraphicsChart id="fx" :option="fxOptions" style="margin-top: 20px"/>
          </div>
          <div class="card-content">
<!--            <div>-->
<!--              <table class="tcf-bb-table">-->
<!--                <thead>-->
<!--                <tr>-->
<!--                  <th rowspan="2" style="width: 120px">日期</th>-->
<!--                  <th rowspan="2" style="width: 120px">不良总数量</th>-->
<!--                  <th v-for="d in qualityDepts" :colspan="d.colspan">{{d.name}}</th>-->
<!--                </tr>-->
<!--                <tr>-->
<!--                  <th v-for="d in qualityBads" :hidden="d.name === '不良总数'?true:false">{{d.name}}</th>-->
<!--                </tr>-->
<!--                </thead>-->
<!--                <tbody>-->
<!--                <tr v-for="(d,index) in dateList">-->
<!--                  <td>{{d}}</td>-->
<!--                  <td v-for="a in qualityBads">{{a.data[index]}}</td>-->
<!--                </tr>-->
<!--                <tr>-->
<!--                  <td>累计</td>-->
<!--                  <td v-for="a in series">{{a.y}}</td>-->
<!--                </tr>-->
<!--                <tr>-->
<!--                  <td>单项不良率</td>-->
<!--                  <td v-for="a in series">{{a.rate}}%</td>-->
<!--                </tr>-->
<!--                </tbody>-->
<!--              </table>-->
<!--            </div>-->
            <div style="margin-top: 20px">
              <table class="tcf-bb-table">
                <thead>
                <tr>
                  <th style="width: 120px">责任部门</th>
                  <th v-for="d in series">{{d.name}}</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td style="width: 120px">不良数量</td>
                  <td v-for="d in series">{{d.y}}</td>
                </tr>
                <tr>
                  <td style="width: 120px">占比</td>
                  <td v-for="d in series">{{d.rate}}%</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </el-col>
      <el-col class="card" style="padding-top: 20px">
        <div class="card-body">
          <div class="card-title">
          </div>
          <div class="card-content">
            <GraphicsChart id="fx2" :option="fxOptions2" style="margin-top: 20px"/>
<!--            <div>-->
<!--              <table class="tcf-bb-table">-->
<!--                <thead>-->
<!--                <tr>-->
<!--                  <th rowspan="2" style="width: 120px">日期</th>-->
<!--                  <th rowspan="2" style="width: 120px">不良总次数</th>-->
<!--                  <th v-for="d in qualityDepts" :colspan="d.colspan">{{d.name}}</th>-->
<!--                </tr>-->
<!--                <tr>-->
<!--                  <th v-for="d in qualityBads" :hidden="d.name === '不良总数'?true:false">{{d.name}}</th>-->
<!--                </tr>-->
<!--                </thead>-->
<!--                <tbody>-->
<!--                <tr v-for="(d,index) in dateList">-->
<!--                  <td>{{d}}</td>-->
<!--                  <td v-for="a in qualityBads">{{a.dataTwo[index]}}</td>-->
<!--                </tr>-->
<!--                <tr>-->
<!--                  <td>累计</td>-->
<!--                  <td v-for="a in series2">{{a.y}}</td>-->
<!--                </tr>-->
<!--                <tr>-->
<!--                  <td>单项不良率</td>-->
<!--                  <td v-for="a in series2">{{a.rate}}%</td>-->
<!--                </tr>-->
<!--                </tbody>-->
<!--              </table>-->
<!--            </div>-->
            <div style="margin-top: 20px">
              <table class="tcf-bb-table">
                <thead>
                <tr>
                  <th style="width: 120px">责任部门</th>
                  <th v-for="d in series2">{{d.name}}</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td style="width: 120px">不良次数</td>
                  <td v-for="d in series2">{{d.y}}</td>
                </tr>
                <tr>
                  <td style="width: 120px">占比</td>
                  <td v-for="d in series2">{{d.rate}}%</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </el-col>

      <el-col class="card" style="padding-top: 20px">
        <div class="card-body">
          <div class="card-title">
            <el-form style="float: right;" :inline="true" size="small" :model="searchForm4"  @submit.native.prevent >
              <el-form-item label="选择日期">
                <el-date-picker
                  v-model="searchForm4.time"
                  format="yyyy年MM月dd日"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="车间">
                <el-select v-model="searchForm4.fxfactory" style="width: 120px" filterable clearable>
                  <el-option v-for="item in factoryList" v-if="item.brand===0||group.dBrand===0||group.dBrand===item.brand" :label="item.simple_name" :value="item.factory_id" />
                </el-select>
              </el-form-item>
              <!--              质检责任-->
              <el-form-item label="部门">
                <el-select v-model="searchForm4.depts" style="width:440px;" clearable multiple placeholder="选择部门" >
                  <el-option v-for="d in qualityDeptList" :label="d.name" :value="d.qdid">{{d.name}}</el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button  icon="el-icon-s-data" type="primary" @click="selectPassQualityInfo">统计</el-button>
              </el-form-item>
            </el-form>
          </div>
          <div class="card-content">
            <div>
              <table class="tcf-bb-table">
                <thead>
                <tr>
                  <th style="width: 120px">责任部门</th>
                  <th v-for="d in oneTimeData">{{d.name}}</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td style="width: 120px">入库单数</td>
                  <td v-for="d in oneTimeData">{{d.finishNum}}</td>
                </tr>
                <tr>
                  <td style="width: 120px">合格单数</td>
                  <td v-for="d in oneTimeData">{{d.oneTime}}</td>
                </tr>
                <tr>
                  <td style="width: 120px">一次性通过率</td>
                  <td v-for="d in oneTimeData">{{d.passRate}}%</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </el-col>

      <el-col class="card" style="padding-top: 20px">
        <div class="card-body">
          <div class="card-title">
            <el-form style="float: right;" :inline="true" size="small" :model="searchForm2"  @submit.native.prevent >
              <el-form-item label="选择日期">
                <el-date-picker
                  v-model="searchForm2.time"
                  format="yyyy年MM月dd日"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="车间">
                <el-select v-model="searchForm2.fxfactory" style="width: 120px" filterable clearable>
                  <el-option v-for="item in factoryList" v-if="item.brand===0||group.dBrand===0||group.dBrand===item.brand" :label="item.simple_name" :value="item.factory_id" />
                </el-select>
              </el-form-item>
<!--              质检责任-->
              <el-form-item label="部门">
                <el-select v-model="searchForm2.depts" style="width:440px;" clearable multiple placeholder="选择部门" >
                  <el-option v-for="d in qualityDeptList" :label="d.name" :value="d.qdid">{{d.name}}</el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button  icon="el-icon-s-data" type="primary" @click="selectProdunumQualityInfo">统计</el-button>
              </el-form-item>
            </el-form>
          </div>
          <div class="card-content">
            <div>
              <table class="tcf-bb-table">
                <thead>
                <tr>
                  <th rowspan="2" style="width: 120px">订单号</th>
                  <th rowspan="2" style="width: 120px">总件数</th>
                  <th rowspan="2" style="width: 120px">不良总件数</th>
                  <th v-for="d in qualityDepts2" :colspan="2">{{d.name}}</th>
                </tr>
                <tr>
                  <th v-for="d in (qualityDepts2.length*2)">{{d%2 === 0?'不良率':'不良数'}}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(d,index) in produnumList">
                  <td>{{d}}</td>
                  <td>{{comnumList[index]}}</td>
                  <td>{{badnumList[index]}}</td>
                  <td v-for="(b,index1) in badNumRate">{{index1%2 === 0?b[index]:b[index]+'%'}}</td>
                </tr>
                <tr>
                  <td>合计</td>
                  <td v-for="(sum,index2) of sumArr">{{sum}}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </el-col>
      <el-col class="card" style="padding-top: 20px">
        <div class="card-body">
          <div class="card-title">
            <el-form style="float: right;" :inline="true" size="small" :model="searchForm3"  @submit.native.prevent >
              <el-form-item label="选择日期">
                <el-date-picker
                  v-model="searchForm3.time"
                  format="yyyy年MM月dd日"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期">
                </el-date-picker>
              </el-form-item>
              <el-form-item label="车间">
                <el-select v-model="searchForm3.fxfactory" style="width: 120px" filterable clearable>
                  <el-option v-for="item in factoryList" v-if="item.brand===0||group.dBrand===0||group.dBrand===item.brand" :label="item.simple_name" :value="item.factory_id" />
                </el-select>
              </el-form-item>
<!--              质检责任-->
              <el-form-item label="部门">
                <el-select v-model="searchForm3.depts" style="width:440px;" clearable multiple placeholder="选择部门" >
                  <el-option v-for="d in qualityDeptList" :label="d.name" :value="d.qdid">{{d.name}}</el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button  icon="el-icon-s-data" type="primary" @click="selectMoneyInfo">统计</el-button>
              </el-form-item>
            </el-form>
          </div>
          <div class="card-content">
            <div>
              <table class="tcf-bb-table">
                <thead>
                <tr>
                  <th rowspan="2" style="width: 120px">周次</th>
                  <th v-for="d in qualityDepts3" :colspan="3">{{d.name}}</th>
                </tr>
                <tr>
                  <th v-for="d in (qualityDepts3.length*3)">{{d%3 === 1?'异常次数':d%3 === 2?'不良件数':'损失金额'}}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(d,index) in weekNumList">
                  <td>{{d}}周</td>
                  <td v-for="b in MoneyInfoData">{{b[index]}}</td>
                </tr>
                <tr>
                  <td>合计</td>
                  <td v-for="sum of sumArr2">{{sum}}</td>
                </tr>
                </tbody>
              </table>
              <GraphicsChart class="Highcharts" id="option" :option="option"/>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import GraphicsChart from '@/components/Charts/GraphicsChart'
import {
  getFactoryList,
  getQualityDeptAll,
  selectQualityInfo,
  selectProdunumQualityInfo,
  selectMoneyInfo,
  getGroupInfoByUser,
  selectPassQualityInfo
} from '@/api/erp'

export default {
  name: 'zjfx',
  components: { GraphicsChart },
  computed: {
    user: getUser
  },
  data() {
    return {
      factoryList: [], // 工厂集合
      qualityDeptList: [], // 质检责任部门
      searchForm: {
        time: [],
        fxfactory: '',
        depts: []
      },
      qualityDepts: [],
      qualityBads: [],
      dateList: [],
      series: [],
      fxOptions: {
        title: false,
        credits: {
          enabled: false
        }
      },
      series2: [],
      fxOptions2: {
        title: false,
        credits: {
          enabled: false
        }
      },
      searchForm2: {
        time: [],
        fxfactory: '',
        depts: []
      },
      qualityDepts2: [],
      produnumList: [],
      comnumList: [],
      badnumList: [],
      badNumRate: [],
      sumArr: [],
      searchForm3: {
        time: [],
        fxfactory: '',
        depts: []
      },
      qualityDepts3: [],
      weekNumList: [],
      MoneyInfoData: [],
      sumArr2: [],
      option: {},
      group: {
        dBrand: 1
      },
      searchForm4: {
        time: [],
        fxfactory: '',
        depts: []
      },
      oneTimeData: []
    }
  },
  created() {
    const myDate = new Date()
    const year = myDate.getFullYear()
    let month = myDate.getMonth() + 1
    let day = myDate.getDate()
    month = month > 9 ? month + '' : '0' + month
    day = day > 9 ? day + '' : '0' + day
    this.searchForm.time.push(year + '-' + month + '-01')
    this.searchForm.time.push(year + '-' + month + '-' + day)
    this.searchForm2.time.push(year + '-' + month + '-01')
    this.searchForm2.time.push(year + '-' + month + '-' + day)
    this.searchForm3.time.push(year + '-' + month + '-01')
    this.searchForm3.time.push(year + '-' + month + '-' + day)
    this.searchForm4.time.push(year + '-' + month + '-01')
    this.searchForm4.time.push(year + '-' + month + '-' + day)
    getGroupInfoByUser({ groupid: this.user.dGroupid }).then(response => {
      this.group = response.data
    })
    getFactoryList().then(response => {
      this.factoryList = response.data
    })
    getQualityDeptAll().then(response => {
      this.qualityDeptList = response.data
    })
    this.getData()
  },
  methods: {
    getData() {
      this.selectQualityInfo()
      this.selectProdunumQualityInfo()
      this.selectMoneyInfo()
      this.selectPassQualityInfo()
    },
    selectPassQualityInfo() {
      let startTime = ''
      let endTime = ''
      if (this.searchForm4.time !== null && this.searchForm4.time.length === 2) {
        startTime = this.searchForm4.time[0]
        endTime = this.searchForm4.time[1]
      }
      const data = {
        startTime: startTime,
        endTime: endTime,
        factory: this.searchForm4.fxfactory,
        depts: this.searchForm4.depts.join(','),
        userid: this.user.dUserid,
        groupid: this.user.dGroupid,
        role: this.user.role
      }
      selectPassQualityInfo(data).then(response => {
        this.oneTimeData = response.data.qualityDepts
      })
    },
    selectMoneyInfo() {
      let startTime = ''
      let endTime = ''
      if (this.searchForm3.time !== null && this.searchForm3.time.length === 2) {
        startTime = this.searchForm3.time[0]
        endTime = this.searchForm3.time[1]
      }
      const data = {
        startTime: startTime,
        endTime: endTime,
        factory: this.searchForm3.fxfactory,
        depts: this.searchForm3.depts.join(','),
        userid: this.user.dUserid,
        groupid: this.user.dGroupid,
        role: this.user.role
      }
      selectMoneyInfo(data).then(response => {
        this.qualityDepts3 = response.data.qualityDepts
        this.weekNumList = response.data.weekNumList
        let MoneyInfoData = []
        let xAxisData = []
        let seriesData = []
        seriesData.push({ name: '异常次数', type: 'column', data: [], tooltip: { valueSuffix: '次' }})
        seriesData.push({ name: '不良件数', type: 'column', data: [], tooltip: { valueSuffix: '件' }})
        seriesData.push({ name: '损失金额', type: 'spline', data: [], tooltip: { valueSuffix: '￥' }, yAxis: 1 })
        for (let qd of this.qualityDepts3) {
          xAxisData.push(qd.name)
          MoneyInfoData.push(qd.data)
          MoneyInfoData.push(qd.dataThree)
          MoneyInfoData.push(qd.dataTwo)
        }
        this.MoneyInfoData = MoneyInfoData
        let sumArr2 = []
        for (let m of this.MoneyInfoData) {
          sumArr2.push(this.sum(m))
        }
        for (let i = 0; i < sumArr2.length; i++) {
          if (i % 3 === 0) {
            seriesData[0].data.push(sumArr2[i])
          }
          if (i % 3 === 1) {
            seriesData[1].data.push(sumArr2[i])
          }
          if (i % 3 === 2) {
            seriesData[2].data.push(sumArr2[i])
          }
        }
        this.sumArr2 = sumArr2
        const chart = {
          chart: {
            zoomType: 'xy'
          },
          credits: {
            enabled: false
          },
          lang: {
            printChart: '打印图表',
            downloadPNG: '下载JPEG 图片',
            downloadJPEG: '下载JPEG文档',
            downloadPDF: '下载PDF 图片',
            downloadSVG: '下载SVG 矢量图',
            contextButtonTitle: '下载图片'
          },
          title: {
            text: '责任部门质量问题次数/件数/金额统计'
          },
          xAxis: {
            categories: xAxisData,
            crosshair: true
          },
          yAxis: [{ // Primary yAxis
            labels: {
              format: '{value}'
            },
            allowDecimals: false,
            title: {
              text: '件数/次数'
            }
          }, { // Secondary yAxis
            title: {
              text: '金额'
            },
            labels: {
              format: '{value}'
            },
            opposite: true
          }],
          tooltip: {
            shared: true
          },
          plotOptions: {
            column: {
              borderWidth: 0
            }
          },
          series: seriesData
        }
        this.option = chart
      })
    },
    selectProdunumQualityInfo() {
      let startTime = ''
      let endTime = ''
      if (this.searchForm2.time !== null && this.searchForm2.time.length === 2) {
        startTime = this.searchForm2.time[0]
        endTime = this.searchForm2.time[1]
      }
      const data = {
        startTime: startTime,
        endTime: endTime,
        factory: this.searchForm2.fxfactory,
        depts: this.searchForm2.depts.join(','),
        userid: this.user.dUserid,
        groupid: this.user.dGroupid,
        role: this.user.role
      }
      selectProdunumQualityInfo(data).then(response => {
        this.qualityDepts2 = response.data.qualityDepts
        this.produnumList = response.data.produnumList
        this.comnumList = response.data.comnumList
        this.badnumList = response.data.badnumList
        let badNumRate = []
        for (let qd of this.qualityDepts2) {
          badNumRate.push(qd.data)
          badNumRate.push(qd.dataTwo)
        }
        this.badNumRate = badNumRate
        let sumArr = []
        sumArr.push(this.sum(this.comnumList))
        sumArr.push(this.sum(this.badnumList))
        for (let a = 0; a < this.badNumRate.length; a++) {
          if (a % 2 === 0) {
            sumArr.push(this.sum(this.badNumRate[a]))
          }
          if (a % 2 === 1) {
            if (this.sum(this.comnumList) > 0) {
              sumArr.push(parseFloat((((this.sum(this.badNumRate[a - 1])) / (this.sum(this.comnumList)) * 100).toFixed(2))) + '%')
            } else {
              sumArr.push(0.00 + '%')
            }
          }
        }
        this.sumArr = sumArr
      })
    },
    selectQualityInfo() {
      let startTime = ''
      let endTime = ''
      if (this.searchForm.time !== null && this.searchForm.time.length === 2) {
        startTime = this.searchForm.time[0]
        endTime = this.searchForm.time[1]
      }
      const data = {
        startTime: startTime,
        endTime: endTime,
        factory: this.searchForm.fxfactory,
        depts: this.searchForm.depts.join(','),
        userid: this.user.dUserid,
        groupid: this.user.dGroupid,
        role: this.user.role
      }
      let cjname = ''
      if (data.factory !== null && data.factory !== '' && data.factory !== undefined) {
        for (const f of this.factoryList) {
          if (data.factory === f.factory_id) {
            cjname = f.simple_name
            break
          }
        }
      }
      selectQualityInfo(data).then(response => {
        this.qualityDepts = response.data.qualityDepts
        this.qualityBads = response.data.qualityBads
        this.dateList = response.data.dateList
        // 不良类别集合中再加入每天的合计不良数量
        let ar = []
        let arr = []
        for (let x = 0; x < this.dateList.length; x++) {
          let sum = 0
          let sum2 = 0
          for (let y = 0; y < this.qualityBads.length; y++) {
            sum += this.qualityBads[y].data[x]
            sum2 += this.qualityBads[y].dataTwo[x]
          }
          ar.push(sum)
          arr.push(sum2)
        }
        this.qualityBads.unshift({ name: '不良总数', data: ar, dataTwo: arr })

        let _series = [] // 数量图数据
        let _series2 = [] // 次数图数据
        for (let a of this.qualityBads) {
          let sum = 0
          for (let b of a.data) {
            sum += b
          }
          _series.push({ name: a.name, y: sum, rate: 0.00, qdid: a.qdid })
          let sum2 = 0
          for (let b of a.dataTwo) {
            sum2 += b
          }
          _series2.push({ name: a.name, y: sum2, rate: 0.00, qdid: a.qdid })
        }
        // 数量图算不良率
        for (let s of _series) {
          if (_series[0].y > 0) {
            s.rate = parseFloat((s.y / (_series[0].y) * 100).toFixed(2))
          } else {
            s.rate = 0.00
          }
        }
        this.series = _series
        // 次数图算不良率
        for (let s of _series2) {
          if (_series2[0].y > 0) {
            s.rate = parseFloat((s.y / (_series2[0].y) * 100).toFixed(2))
          } else {
            s.rate = 0.00
          }
        }
        this.series2 = _series2
        // 计算按部门划分各部门数据 和 各部门加一块的总数据
        let dataSum = 0 // 各部门数量之和
        let dataSum2 = 0 // 各部门次数之和
        for (let q of this.qualityDepts) {
          let sum = 0 // 数量
          let rate = 0.00 // 数量不良率
          let sum2 = 0 // 次数
          let rate2 = 0.00 // 次数不良率
          for (let b of this.series) {
            if (q.qdid === b.qdid) {
              sum += b.y
              rate += b.rate
            }
          }
          q.num = sum
          q.rate = rate.toFixed(2)
          dataSum += sum
          for (let b of this.series2) {
            if (q.qdid === b.qdid) {
              sum2 += b.y
              rate2 += b.rate
            }
          }
          q.num2 = sum2
          q.rate2 = rate2.toFixed(2)
          dataSum2 += sum2
        }
        this.qualityDepts.unshift({ name: '不良总数', num: dataSum, rate: isNaN((dataSum / dataSum * 100).toFixed(2)) === true ? 0.00 : (dataSum / dataSum * 100).toFixed(2), num2: dataSum2, rate2: isNaN((dataSum2 / dataSum2 * 100).toFixed(2)) === true ? 0.00 : (dataSum2 / dataSum2 * 100).toFixed(2) })
        // 根据需求在原有的基础上增加的代码   start！！！
        let _seriesOne = []
        let _seriesTwo = []
        for (let a of this.qualityDepts) {
          _seriesOne.push({ name: a.name, y: a.num, rate: isNaN((a.num / dataSum2 * 100).toFixed(2)) === true ? 0.00 : (a.num / dataSum * 100).toFixed(2), qdid: a.qdid })
          _seriesTwo.push({ name: a.name, y: a.num2, rate: isNaN((a.num2 / dataSum2 * 100).toFixed(2)) === true ? 0.00 : (a.num2 / dataSum2 * 100).toFixed(2), qdid: a.qdid })
        }
        this.series = _seriesOne
        this.series2 = _seriesTwo
        // 根据需求在原有的基础上增加的代码   end！！！
        //
        // 图1
        const chart = {
          lang: {
            printChart: '打印图表',
            downloadPNG: '下载JPEG 图片',
            downloadJPEG: '下载JPEG文档',
            downloadPDF: '下载PDF 图片',
            downloadSVG: '下载SVG 矢量图',
            contextButtonTitle: '下载图片'
          },
          credits: {
            enabled: false
          },
          chart: {
            type: 'column'
          },
          title: {
            text: cjname + '单项不良率(数量)'
          },
          xAxis: {
            type: 'category'
          },
          yAxis: {
            min: 0,
            title: false
          },
          legend: {
            enabled: false
          },
          plotOptions: {
            series: {
              borderWidth: 0,
              dataLabels: {
                enabled: true,
                format: '{point.rate}%'
              }
            }
          },
          tooltip: {
            pointFormat: '<span style="color:{point.color}">不良数量</span>: <b>{point.y}</b>件<br/>' +
              '<span style="color:{point.color}">不良率</span>: <b>{point.rate}</b> %<br/>'
          },
          series: [{
            colorByPoint: true,
            data: _seriesOne
          }]
        }
        this.fxOptions = chart
        // 图二
        const chart2 = {
          lang: {
            printChart: '打印图表',
            downloadPNG: '下载JPEG 图片',
            downloadJPEG: '下载JPEG文档',
            downloadPDF: '下载PDF 图片',
            downloadSVG: '下载SVG 矢量图',
            contextButtonTitle: '下载图片'
          },
          credits: {
            enabled: false
          },
          chart: {
            type: 'column'
          },
          title: {
            text: cjname + '单项不良率(次数)'
          },
          xAxis: {
            type: 'category'
          },
          yAxis: {
            min: 0,
            title: false
          },
          legend: {
            enabled: false
          },
          plotOptions: {
            series: {
              borderWidth: 0,
              dataLabels: {
                enabled: true,
                format: '{point.rate}%'
              }
            }
          },
          tooltip: {
            pointFormat: '<span style="color:{point.color}">不良次数</span>: <b>{point.y}</b>次<br/>' +
              '<span style="color:{point.color}">不良率</span>: <b>{point.rate}</b> %<br/>'
          },
          series: [{
            colorByPoint: true,
            data: _seriesTwo
          }]
        }
        this.fxOptions2 = chart2
      })
    },
    sum(arr) {
      var s = 0
      for (var i = arr.length - 1; i >= 0; i--) {
        s += arr[i]
      }
      return s
    }
  }
}
</script>

<style lang="scss" scoped>
  .tcf-bb-table{
    width: 100%;
    background-color: #fff;
    border-collapse: collapse;
    border-spacing: 0;
    font-size: 13px;
    text-align: center;
  thead{
    color: #909399;
    font-weight: 500;
  tr{
  th{
    border: 1px solid #EBEEF5;
    background: #f6f8fa;
    color: #303133;
    padding: 10px;
  }
  }
  }
  tbody{
  tr{
  th{
    border: 1px solid #EBEEF5;
    background: #f6f8fa;
    color: #303133;
    padding: 10px;
  }
  td{
    border: 1px solid #EBEEF5;
    color: #303133;
    padding: 12px 0;
  }
  &:hover{
     background: #f3f6f9;
   }
  }
  }
  }
</style>
